import { useState } from "react";
import testimonialUsers from "../data/testimonials.json";
import { BsCheck2, BsStar, BsStarFill, BsStarHalf } from "react-icons/bs";
import { AiOutlineComment } from "react-icons/ai";

const Testimonials = () => {
  console.log(testimonialUsers);
  const [state, setState] = useState(testimonialUsers);
  return (
    <div className="py-[140px] bg-gradient-to-t from-teal-50 to-teal-50 dark:from-gray-900 dark:to-gray-800 ">
      <div className="container-block ">
        <div className="flex flex-wrap items-center">
          <div className="w-full md:w-12/12">
            <div className="flex flex-wrap -mx-5">
              {state.map((comment) => (
                <div
                  className="w-full md:w-4/12 p-5 mt-2 relative"
                  key={comment.id}
                >
                  <span className="block absolute top-10 left-10 -z-10">
                    <AiOutlineComment
                      size={50}
                      className="opacity-[.2] text-teal-500"
                    />
                  </span>

                  <p className="text-sm text-gray-800 dark:text-gray-200 font-medium leading-[25px]">
                    {comment.comment.slice(0, 130)}
                  </p>
                  <div className="flex items-center mt-3">
                    <div className="w-[55px] h-[55px] rounded-full overflow-hidden">
                      <img
                        src={comment.user}
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </div>
                    <div className="ml-3">
                      <span className="block text-[14px] text-gray-600 font-semibold capitalize dark:text-white">
                        {comment.name}
                      </span>
                      <span className="flex">
                        <BsStarFill
                          size={12}
                          className="first:ml-0 ml-[2px]"
                          color="#0f766e"
                        />
                        <BsStarFill
                          size={12}
                          className="first:ml-0 ml-[2px]"
                          color="#0f766e"
                        />
                        <BsStarFill
                          size={12}
                          className="first:ml-0 ml-[2px]"
                          color="#0f766e"
                        />
                        <BsStarFill
                          size={12}
                          className="first:ml-0 ml-[2px]"
                          color="#0f766e"
                        />
                        <BsStarFill
                          size={12}
                          className="first:ml-0 ml-[2px]"
                          color="#0f766e"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
